var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyAddress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 23,
    viewBox: "0 0 19 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_1134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5407 12.4972H8.1517C7.87103 12.4785 7.72133 12.3286 7.70262 12.0478V4.85674C7.72133 4.57584 7.87103 4.42603 8.1517 4.4073H12.0812L13.9898 6.31741V12.0478C13.9711 12.3286 13.8214 12.4785 13.5407 12.4972ZM8.1517 13.8455H13.5407C14.0459 13.8268 14.4669 13.6489 14.8038 13.3118C15.1406 12.9747 15.3183 12.5534 15.337 12.0478V6.31741C15.337 5.94288 15.2061 5.62453 14.9441 5.36236L13.0355 3.45224C12.7735 3.19007 12.4554 3.05899 12.0812 3.05899H8.1517C7.64648 3.07771 7.22547 3.25562 6.88866 3.59269C6.55184 3.92977 6.37408 4.35112 6.35537 4.85674V12.0478C6.37408 12.5534 6.55184 12.9747 6.88866 13.3118C7.22547 13.6489 7.64648 13.8268 8.1517 13.8455ZM4.55903 6.65449C4.05381 6.67322 3.6328 6.85112 3.29598 7.1882C2.95917 7.52528 2.78141 7.94663 2.7627 8.45225V15.6433C2.78141 16.1489 2.95917 16.5702 3.29598 16.9073C3.6328 17.2444 4.05381 17.4223 4.55903 17.441H9.94804C10.4533 17.4223 10.8743 17.2444 11.2111 16.9073C11.5479 16.5702 11.7257 16.1489 11.7444 15.6433V14.7444H10.3971V15.6433C10.3784 15.9242 10.2287 16.074 9.94804 16.0927H4.55903C4.27835 16.074 4.12866 15.9242 4.10995 15.6433V8.45225C4.12866 8.17135 4.27835 8.02153 4.55903 8.00281H5.4572V6.65449H4.55903Z",
    fill: "#ADB5BD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_1134"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.68,
    height: 15,
    fill: "white",
    transform: "matrix(1 0 0 -1 2.70996 17.75)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyAddress);
export default __webpack_public_path__ + "static/media/Copy Address.20bd28e57ee75a31f17a65ebfde08f5e.svg";
export { ForwardRef as ReactComponent };